<div class="pap-plan-filter border-r-16" *transloco="let t">
  <div class="left-section" [formGroup]="filterForm">
    <div class="form-group">
      <app-date-range-filter
        class="w-100"
        [filterForm]="filterForm"
        [localStorageKey]="'dateRangeFilterPapPlan'"
        [formControlDateQuickRangeKeyName]="'dateQuickRangeKey'"
        [formControlDateStartName]="'dateStart'"
        [formControlDateEndName]="'dateEnd'"
      >
      </app-date-range-filter>
    </div>
    <div class="form-group" *ngIf="teachers$ | async as teachers">
      <ng-select
        id="teacher"
        formControlName="teacherId"
        [items]="teachers"
        bindLabel="fullName"
        bindValue="id"
        [placeholder]="t('pap/plan/teacher')"
        class="form-control form-control-rounded floating-placeholder"
        [ngClass]="{ active: !!filterForm.get('teacherId')?.value }"
        [typeahead]="fetchTeachers$"
        [minTermLength]="2"
      ></ng-select>
    </div>
    <div class="form-group search-pap-plan-target">
      <i class="material-symbols-rounded prepend-icon">search</i>
      <input
        formControlName="search"
        type="text"
        class="form-control form-control-rounded form-control-prepend"
        [ngClass]="{ active: !!filterForm.get('search')?.value }"
        [placeholder]="t('pap/plan/search')"
      />
    </div>
    <div class="form-group">
      <ng-select
        id="teacherTargetState"
        formControlName="state"
        [items]="targetStates"
        bindLabel="text"
        bindValue="value"
        [placeholder]="t('pap/plan/state')"
        [searchable]="false"
        class="form-control form-control-rounded floating-placeholder"
        [ngClass]="{ active: !!filterForm.get('state')?.value }"
      >
      </ng-select>
    </div>
  </div>

  <div class="right-section">
    <button (click)="printPage()" class="btn btn-outline-primary btn-icon">
      <isophi-print-download-icon></isophi-print-download-icon>
      {{ t('shared/printDownload') }}
    </button>
    <button (click)="exportPage()" class="btn btn-outline-primary btn-icon">
      <i class="material-symbols-rounded">download</i>
      {{ t('shared/export') }}
    </button>
  </div>
</div>
